export default __webpack_public_path__ + "static/media/icon-done.becccdf0.png";